module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/企业文化核心内容.7ab7f40f.png";